export default "__VITE_ASSET__yfx_rZtb__"